import { useTranslation } from "react-i18next";
import {
  ContentHeader,
  DesignTokens,
  MainContentArea,
  Text,
  Title,
  ValueOrFallback,
} from "melco-ui";
import styled from "styled-components";
import { useBreadcrumb } from "../../hooks/navigation/useBreadcrumb";
import { JoinBetaTestingButton } from "../../components/reporting/proReporting/JoinBetaTestingButton";
import ImageCarousel from "../../components/imagecarousel/ImageCarousel";

import embroideryBravo from "../../images/embroidery-bravo.jpg";
import embroideryEmt16xNewCart from "../../images/embroidery-emt16x-newcart.jpg";
import submitObererBereich from "../../images/submit-oberer-bereich.png";

export const ProReporting: React.FC = () => {
  const { t } = useTranslation();

  const { spacings } = DesignTokens;
  const breadcrumb = useBreadcrumb("reporting");


  const CarouselWrapper = styled.div`
  margin-bottom: ${spacings.xlarge}px; /* spacing between title and carousel */
`;

  const ButtonWrapper = styled.div`
  margin-top: ${spacings.xlarge}px; /* spacing between text and button */
  padding-top: ${spacings.small}px;
  `;



  return (
    <MainContentArea
      header={
        <ContentHeader
          title={
            <ValueOrFallback
              value={t("reporting.proreporting.title")}
              fallback={t("global.fallback.empty")}
            />

          }
          breadcrumb={breadcrumb}
          extra={<></>}
        />
      }
      contentPadding
    >
      {
        <>  {/* Carousel with spacing  */}
          <CarouselWrapper>
            <ImageCarousel
              items={[
                {
                  imgSrc: embroideryBravo,
                  text: t("reporting.proreporting.text.carousel1")
                },
                {
                  imgSrc: embroideryEmt16xNewCart,
                  text: t("reporting.proreporting.text.carousel2"),
                },
                {
                  imgSrc: submitObererBereich,
                  text: t("reporting.proreporting.text.carousel3"),
                },
              ]}
              slidesToShow={3}
              key="pro-reporting-image-carousel"
            />
          </CarouselWrapper>
          {/* Title below carousel */}
          <Title level={4} style={{ marginTop: spacings.xlarge }}>
            {t("reporting.proreporting.text.line1")}
          </Title>

          <Text>{t("reporting.proreporting.text.line2")}</Text>
          <ButtonWrapper>
            <JoinBetaTestingButton />
          </ButtonWrapper>


        </>
      }
    </MainContentArea>
  );
};
